export default __webpack_public_path__ + "static/media/canaryPointLogo.11663d9e.png";